// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Condition
 */
export interface Condition {
  /**
   *
   * @type {string}
   * @memberof Condition
   */
  lastTransitionTime?: string;
  /**
   *
   * @type {string}
   * @memberof Condition
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof Condition
   */
  reason?: string;
  /**
   *
   * @type {string}
   * @memberof Condition
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof Condition
   */
  type?: string;
}

/**
 * Check if a given object implements the Condition interface.
 */
export function instanceOfCondition(value: object): value is Condition {
  return true;
}

export function ConditionFromJSON(json: any): Condition {
  return ConditionFromJSONTyped(json, false);
}

export function ConditionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Condition {
  if (json == null) {
    return json;
  }
  return {
    lastTransitionTime:
      json['lastTransitionTime'] == null
        ? undefined
        : json['lastTransitionTime'],
    message: json['message'] == null ? undefined : json['message'],
    reason: json['reason'] == null ? undefined : json['reason'],
    status: json['status'] == null ? undefined : json['status'],
    type: json['type'] == null ? undefined : json['type'],
  };
}

export function ConditionToJSON(json: any): Condition {
  return ConditionToJSONTyped(json, false);
}

export function ConditionToJSONTyped(
  value?: Condition | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    lastTransitionTime: value['lastTransitionTime'],
    message: value['message'],
    reason: value['reason'],
    status: value['status'],
    type: value['type'],
  };
}
